import axios from "axios";

export default ({ dispatch, getState, next, action }) => {
    const { type, payload } = action;
    if (type === "CVS2:SUBMIT-CREDENTIALS") {
        axios.post("/cvs/credentials", { ...payload })
            .then(res => dispatch({
                type: "CVS2:SUBMIT-CREDENTIALS-SUCCESS"
            }))
            .catch(error => {
                const { message } = error;
                dispatch({
                    type: "CVS2:SUBMIT-CREDENTIALS-FAILURE",
                    payload: { credentialsError: message }
                });
            });
    } else if (type === "CVS2:FETCH-GCP-PROJECTS") {
        axios.get("/cvs/gcp/projects", {
            data: { ...payload }
        })
            .then(gcpProjects => dispatch({
                type: "CVS2:FETCH-GCP-PROJECTS-SUCCESS",
                payload: { gcpProjects }
            }))
            .catch(error => {
                const { message } = error;
                dispatch({
                    type: "CVS2:FETCH-GCP-PROJECTS-FAILURE",
                    payload: { credentialsError: message }
                });
            });
    }
    return next(action);
};
